import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

/** Any path no route matches (GOD-59) – before, this was an empty page. */
export default function NotFound() {
    const { t } = useTranslation();
    const location = useLocation();
    return (
        <div className="container py-5" style={{ maxWidth: 560 }} data-testid="not-found">
            <div className="gl-meta mb-2">404</div>
            <h1 className="h3 mb-3">{t("notFound.title")}</h1>
            <p className="text-muted">
                {t("notFound.text")} <code>{location.pathname}</code>
            </p>
            <Link className="btn btn-primary" to="/">
                {t("notFound.home")}
            </Link>
        </div>
    );
}
